import { ThreeBounce } from "better-react-spinkit";
const Loading = () => {
  return (
    <center className="grid place-items-center h-screen bg-gray-900">
      <div>
        <ThreeBounce size={50} color="pink" />
      </div>
    </center>
  );
};

export default Loading;
